import React from "react";
import { Box, Button, Grid } from "@mui/material";

import YearlyFilter from "components/pages/nonCompliantPatients/filters/YearlyFilter";
import MonthlyFilter from "components/pages/nonCompliantPatients/filters/MonthlyFilter";
import NoShowTypeFilter from "components/pages/nonCompliantPatients/filters/NoShowTypeFilter";
import { Download } from "@mui/icons-material";
import LoadingSpinner from "components/LoadingSpinner";
import DownloadOverduePatientFilterModal from "../modal/DownloadOverduePatientFilterModal";
import useNonCompliantPatientToolbar from "../hooks/useNonCompliantPatientToolbar";

const NonCompliantPatientToolbar = () => {
  const {
    handleDownloadOverduePatients,
    handleDownloadOverduePatientModal,
    isDownloadingOverdueList,
    showDownloadOverdueModal,
  } = useNonCompliantPatientToolbar();
  return (
    <>
      <div className="d-flex justify-between table-toolbar">
        <Grid container alignItems="center" spacing={1}>
          <Grid container item columnSpacing={1} xs={8} sm={4} md={2}>
            <Grid item xs={6} sm={6} md={6}>
              <YearlyFilter />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <MonthlyFilter />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <NoShowTypeFilter />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          color="secondary"
          onClick={() => handleDownloadOverduePatientModal(true)}
          disabled={isDownloadingOverdueList}
          sx={{
            alignSelf: "flex-start",
            whiteSpace: "nowrap",
            minHeight: "32px",
            marginTop: "16px",
          }}
        >
          <Box sx={{ px: 2, display: "flex", alignItems: "center" }}>
            {isDownloadingOverdueList ? (
              <LoadingSpinner size={16} />
            ) : (
              <Download fontSize="small" />
            )}
            <span className="ml-2">Download Overdue Patients</span>
          </Box>
        </Button>
      </div>
      {showDownloadOverdueModal && (
        <DownloadOverduePatientFilterModal
          handleDownloadOverduePatient={handleDownloadOverduePatients}
        />
      )}
    </>
  );
};

export default NonCompliantPatientToolbar;
